/** Signed-in user profile shown in the account menu and settings. */
export const USER_PROFILE = {
  fullName: 'Shivprasad C',
  firstName: 'Shivprasad',
  /** Short name used in the home welcome hero. */
  greetingName: 'Shiva',
  lastName: 'C',
  email: 'shiva.p@gmail.com',
}
